module.exports = __webpack_public_path__ + "./images/kingspan-logo-full.svg";